import { createGuid, ScreenSpaceEventType, } from "cesium";
import { Site } from "../../site/site";
import { ConstructionState } from "../../site/trench/earthbrain-trench";
import { FlatGround, FlatGroundOperation, } from "../../site/flatground/earthbrain-flatground";
import { AddPoinToFlatGroundCommand } from "./flatground-command";
import { FlatGroundStructure } from "../../site/flat-ground-structure";
import { getDefaultFlatGroundSettings } from "../../settings/earthbrain-site-settings";
import { PositionReference, checkPositionWrtToTileset, } from "../../utilities/local-utilities";
import { CesiumPointSelectorType, } from "../../cesium-utils/point-selector/point-selector";
export class FlatgroundConstructionHandler {
    _callback;
    _flatgroundUnderConstruction;
    _viewer;
    _preview;
    _handler;
    _commandManager;
    _cesiumPicker;
    _cesiumPointSelector;
    _finishFlatGroundConstructionHandler;
    _cesiumViewer;
    _site;
    get flatGround() {
        return this._flatgroundUnderConstruction;
    }
    constructor(args, cesiumViewer) {
        this._site = args.site;
        this._viewer = args.viewer;
        this._preview = args.preview;
        this._handler = args.handler;
        this._commandManager = args.commandManger;
        this._cesiumPicker = args.cesiumPicker;
        this._cesiumPointSelector =
            args.cesiumPointSelectorFactory.getPointSelector(CesiumPointSelectorType.PriorityBased);
        this._cesiumViewer = cesiumViewer;
    }
    _mosueMoveDebounce = undefined;
    _debunceHandlerForSphereMovement(movement) {
        if (this._mosueMoveDebounce) {
            clearTimeout(this._mosueMoveDebounce);
            this._mosueMoveDebounce = undefined;
        }
        this._mosueMoveDebounce = setTimeout(() => {
            this._functionForPreviewSphereMovement(movement);
            this._mosueMoveDebounce = undefined;
        }, 100);
    }
    async _functionForPreviewSphereMovement(movement) {
        const cartesian = await this._cesiumPointSelector.getPointOnMousePos(movement.endPosition);
        if (cartesian) {
            this._preview.disposePreviewFlatGroundEntity();
            this._preview.setSpherePosition(cartesian);
            this._preview.setLinePosition([]);
            // add point to the flatGround id the ditance between it and last point is less than 10 KM
            if (this._flatgroundUnderConstruction.GroundPointsCount > 1) {
                this._preview.updateFlatGroundPreviewEntity(this._flatgroundUnderConstruction, cartesian, FlatGroundOperation.CREATION);
            }
            this._viewer.scene.requestRender();
        }
    }
    async addPointOnLeftClick({ position: mousePos, }) {
        const site = Site.getInstance();
        const previewPos = await this._cesiumPointSelector.getPointOnMousePos(mousePos);
        if (previewPos) {
            const arr = await site.convertPointsToLocalSpace([previewPos]);
            const localPos = arr[0];
            const positionRef = checkPositionWrtToTileset(localPos, this._flatgroundUnderConstruction.associatedTerrain);
            const pickedInfo = positionRef !== PositionReference.OUTSIDE
                ? this._cesiumPicker.getPickablePickedInfo(mousePos)
                : undefined;
            // Do not process further
            if (positionRef === PositionReference.OUTSIDE) {
                this.raiseEventInvalidCtrlPtForRoad(this._flatgroundUnderConstruction.id);
                return;
            }
            if (!localPos) {
                console.error("Cound not find the Point");
                return;
            }
            if (previewPos) {
                this._commandManager.action(new AddPoinToFlatGroundCommand(this._flatgroundUnderConstruction, { position: previewPos, info: pickedInfo, localPosition: localPos }, () => {
                    const flatgroundPoints = this._flatgroundUnderConstruction._pointsForFlatGround.map((p) => p.position);
                    this._preview.setOutlinePreviewOnFlatGroundEdit(flatgroundPoints);
                    this._preview.updateFlatGroundPreview(this._flatgroundUnderConstruction);
                }), this._cesiumViewer);
                this._preview.setLineVisibility(true);
                this._preview.setLinePosition([]);
            }
            this._callback.onProgress &&
                this._callback.onProgress(this._flatgroundUnderConstruction.id, 0);
        }
    }
    //   private _onMouseRightDown() {
    //     this._isMouseRightClicked = true;
    //     this._handler.setInputAction(this._onMouseRightUp.bind(this), Cesium.ScreenSpaceEventType.RIGHT_UP);
    //   }
    //   private _onMouseRightUp() {
    //     this._isMouseRightClicked = false;
    //     this._handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_UP);
    //   }
    start(callback, associatedTerrain, associatedRubbingDestination) {
        this._callback = callback;
        this._flatgroundUnderConstruction = new FlatGround(this._viewer, this._preview, createGuid(), getDefaultFlatGroundSettings(), associatedRubbingDestination, associatedTerrain);
        this._flatgroundUnderConstruction.constructionState =
            ConstructionState.UNDER_CONSTRUCTION;
        this._preview.setSphereVisibility(true);
        this._preview.previewArrowRenderStatus = false;
        this._preview.setOutlinePreviewOnFlatGroundEdit([], { width: 1, alpha: 1 });
        this._handler.setInputAction(this._debunceHandlerForSphereMovement.bind(this), ScreenSpaceEventType.MOUSE_MOVE);
        this._handler.setInputAction(this.addPointOnLeftClick.bind(this), ScreenSpaceEventType.LEFT_CLICK);
        this._finishFlatGroundConstructionHandler =
            this._finishRoadConstruction.bind(this);
        document.addEventListener("keydown", this._finishFlatGroundConstructionHandler);
    }
    _finishRoadConstruction(event) {
        switch (event.key) {
            case "Esc":
            case "Escape":
                this.cancel();
                break;
            case "Enter":
                this.finish();
                break;
            default:
        }
    }
    finish() {
        this._commandManager.clear();
        if (this._flatgroundUnderConstruction.points.length > 2) {
            this._flatgroundUnderConstruction.computeCentralGeometry();
            this._flatgroundUnderConstruction.constructionState =
                ConstructionState.READY;
            this._site.addFlatGround(this._flatgroundUnderConstruction);
            const flatGroundStructure = new FlatGroundStructure(this._flatgroundUnderConstruction);
            this._site.structureManager.addStructure(this._flatgroundUnderConstruction.id, flatGroundStructure);
            const connectionNodes = flatGroundStructure.getConnectionNodes();
            for (const node of connectionNodes) {
                this._site.structureManager.addConnection(node);
            }
            this._preview.setLineVisibility(false);
            this._preview.setSphereVisibility(false);
            this._preview.updateFlatGroundPreviewEntity(this._flatgroundUnderConstruction, undefined, FlatGroundOperation.FINISH);
            this._flatgroundUnderConstruction.setUniformPointsHeight();
            this._flatgroundUnderConstruction.updateSpheresPositionAndLabel();
            // this._viewer.scene.requestRender();
            this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this._finishFlatGroundConstructionHandler &&
                document.removeEventListener("keydown", this._finishFlatGroundConstructionHandler);
            this._finishFlatGroundConstructionHandler = undefined;
            this._callback.onFinish &&
                this._callback.onFinish(this._flatgroundUnderConstruction.id);
        }
        else {
            console.warn("Flat Ground needs atleast 3 points.");
            this.cancel();
        }
    }
    cancel() {
        this._preview.updateFlatGroundPreviewEntity(this._flatgroundUnderConstruction, undefined, FlatGroundOperation.FINISH);
        if (this._flatgroundUnderConstruction) {
            this._flatgroundUnderConstruction.dispose();
        }
        this._flatgroundUnderConstruction = undefined;
        this._preview.setSphereVisibility(false);
        this._preview.setLineVisibility(false);
        this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        this._finishFlatGroundConstructionHandler &&
            document.removeEventListener("keydown", this._finishFlatGroundConstructionHandler);
        this._viewer.scene.requestRender();
        this._callback?.onCancel && this._callback.onCancel();
    }
    raiseEventInvalidCtrlPtForRoad(roadID) {
        const event = new CustomEvent("invalidControlPointForRoad", {
            detail: { roadID, type: 0 },
        });
        window.dispatchEvent(event);
        this._callback.onError && this._callback.onError();
    }
}
//# sourceMappingURL=flatground-construction-handler.js.map